module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('list', {
    attrs: {
      "listTitle": _vm.$t('magalu.accounts.label'),
      "listLogo": _vm.definitionModule.logo,
      "filterTitle": "Filtros",
      "typesListAvailable": ['displayList'],
      "loading": _vm.loadingSearch || _vm.loadingAddAccount,
      "total": _vm.magaluAccountsTotal,
      "sortFields": _vm.sortFields,
      "sortDefault": {
        field: _vm.sortFields[0],
        order: 'asc'
      }
    },
    on: {
      "change": _vm.onChange
    }
  }, [_c('div', {
    staticClass: "btnGroup",
    attrs: {
      "slot": "header-actions"
    },
    slot: "header-actions"
  }, [_c('button', {
    staticClass: "hint hint--left btn btn--info",
    attrs: {
      "slot": "header-actions",
      "data-label": "Adicionar conta"
    },
    on: {
      "click": function($event) {
        _vm.modalAddAccountFlag = true
      }
    },
    slot: "header-actions"
  }, [_c('i', {
    staticClass: "icon-plus"
  })])]), _vm._v(" "), _c('template', {
    slot: "filters"
  }, [_c('form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.name),
      expression: "options.name"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.options.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.options, "name", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _vm._l((_vm.magaluAccounts), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "l-col-4@md"
    }, [_c('account', {
      attrs: {
        "account": item,
        "accountKey": index
      }
    })], 1)
  }), _vm._v(" "), (!_vm.magaluAccounts.length) ? _c('div', {
    staticClass: "l-col u-textCenter"
  }, [_c('panel', [_vm._v("\n        Nenhuma conta foi encontrada.\n      ")])], 1) : _vm._e()], 2), _vm._v(" "), _c('modal-add-account', {
    on: {
      "confirm": _vm.redirectToAuthorizationUrl
    },
    model: {
      value: (_vm.modalAddAccountFlag),
      callback: function($$v) {
        _vm.modalAddAccountFlag = $$v
      },
      expression: "modalAddAccountFlag"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e094ed1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MarketplaceAccount/Magalu/List.vue
// module id = 3458
// module chunks = 0